interface options {
  target: string;
}

export function tab(obj) {
  class Tab {
    tabTarget: NodeListOf<Element>;

    constructor(obj: options) {
      this.tabTarget = document.querySelectorAll(`.${obj.target}-trigger`);
      this.init();
    }

    init(){
      this.tabTarget.forEach((target) => {
        this.onTab(target);
      });
    }

    onTab(target: Element) {
      target.addEventListener('click', (e) => {
        e.preventDefault();
        const parent = (e.target as Element).closest(`.${obj.target}`);
        const headList = parent.querySelectorAll(`.${obj.target}-trigger`);
        const bodyList = parent.querySelectorAll(`.${obj.target}-panel`);

        headList.forEach((head) => {
          head.classList.remove('is-active');
        });
        bodyList.forEach((body) => {
          body.classList.remove('is-active');
        });

        const targetIndex = Array.prototype.indexOf.call(headList, e.target);

        (e.target as Element).classList.add('is-active');
        bodyList[targetIndex].classList.add('is-active');
      });
    }
  }
  new Tab(obj);
}